import { render, staticRenderFns } from "./naj-alert.vue?vue&type=template&id=7bc0ed89&scoped=true&"
import script from "./naj-alert.vue?vue&type=script&lang=js&"
export * from "./naj-alert.vue?vue&type=script&lang=js&"
import style0 from "./naj-alert.vue?vue&type=style&index=0&id=7bc0ed89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc0ed89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
